<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    class="heroicon-magnify heroicon heroicons-lg"
  >
    <path
      class="heroicon-magnify-glass-edge heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M70 36a34 34 0 1 1-68 0 34 34 0 0 1 68 0z"
    ></path>
    <path
      class="heroicon-magnify-glass heroicon-component-fill"
      fill="#FFFFFF"
      d="M61 36a25 25 0 1 1-50 0 25 25 0 0 1 50 0z"
    ></path>
    <polygon
      class="heroicon-magnify-handle heroicon-component-fill"
      fill="#FFFFFF"
      points="94.879 87.707 75.293 68.121 68.121 75.293 87.707 94.879"
    ></polygon>
    <path
      class="heroicon-magnify-handle-connector heroicon-component-fill"
      fill="#FFFFFF"
      d="M63.92 58.73L65.16 60 60 65.17l-1.26-1.26a36.22 36.22 0 0 0 5.18-5.18zm-.5 5.86l1.17-1.18 4 4-1.18 1.18-4-4z"
    ></path>
    <path
      class="heroicon-magnify-handle-edge heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M90 97.17l-1.59-1.58 7.18-7.18L97.17 90 90 97.17zM73 65.83l1.59 1.58-7.18 7.18L65.83 73 73 65.83z"
    ></path>
    <path
      class="heroicon-shadows"
      fill="#000000"
      d="M6.04 37.5a30 30 0 1 1 59.93 0 30 30 0 0 0-59.93 0z"
      opacity=".2"
    ></path>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M65.14 57.14l1.45 1.45L68 60l-1.41 1.41L66 62l4 4 1.59-1.59L73 63l1.41 1.41L76 66l.7.7 19.6 19.6.7.7 1.59 1.59L100 90l-1.41 1.41-7.18 7.18L90 100l-1.41-1.41L87 97l-.7-.7-19.6-19.6-.7-.7-1.59-1.59L63 73l1.41-1.41L66 70l-4-4-.59.59L60 68l-1.41-1.41-1.45-1.45h.01a36 36 0 1 1 8-8zM70 36a34 34 0 1 0-68 0 34 34 0 0 0 68 0zm-6.08 22.73a36.22 36.22 0 0 1-5.18 5.18L60 65.17 65.17 60l-1.26-1.26zm-.5 5.86l4 4 1.17-1.18-4-4-1.18 1.18zM90 97.17L97.17 90l-1.58-1.59-7.18 7.18L90 97.17zm4.88-9.46L75.29 68.12l-7.17 7.17 19.59 19.59 7.17-7.17zM73 65.83L65.83 73l1.58 1.59 7.18-7.18L73 65.83zM66 36a30 30 0 1 1-60 0 30 30 0 0 1 60 0zM36 65a29 29 0 1 0 0-58 29 29 0 0 0 0 58zm0-2a27 27 0 1 1 0-54 27 27 0 0 1 0 54zm25-27a25 25 0 1 0-50 0 25 25 0 0 0 50 0zM36 15v1a20 20 0 0 0-17.9 28.95l-.89.44A21 21 0 0 1 36 15zm37.65 61.35l.7-.7 14 14-.7.7-14-14z"
    ></path>
  </svg>
</template>
